/**
 * Namespace de TOUTES les clés persistées par l'application : localStorage,
 * préférences de tableaux, réglages. Toute clé commence par
 * `${APP_NAMESPACE}.` — sans cette convention, on retrouve six clés orphelines
 * en deux ans, et on n'ose plus en supprimer aucune.
 *
 * ─── Exception assumée : `index.html` ───
 *
 * Le script en ligne qui applique le thème avant la première peinture ne peut
 * PAS importer ce module (il s'exécute avant tout bundle). La chaîne `'myapp'`
 * y est donc répétée à la main : LES DEUX DOIVENT RESTER SYNCHRONISÉS. Changer
 * la constante ici sans toucher `index.html` rend le script de première
 * peinture aveugle à la préférence mémorisée — flash blanc au chargement pour
 * les utilisateurs en thème sombre.
 */
export const APP_NAMESPACE = 'myapp' as const
